import React, { useEffect } from "react";

import {
  emitLinkingNotification,
  emitUpsellNotification,
} from "@catchoftheday/analytics";
import { toast } from "@catchoftheday/cg-components";
import { useCustomerQuery } from "@catchoftheday/customer";
import { withApollo } from "@catchoftheday/graphql-utils";

import { getQueryStringValue } from "@header/utilities";

import {
  NotificationToastContainer,
  NotificationToastContent,
} from "../NotificationToast/components";

export const OnePassNotification = () => {
  const { data } = useCustomerQuery({ ssr: false });
  const { membership, club } = data?.customer || {};

  const containerId = "notification-toast";
  const showMessageQueryParam = getQueryStringValue("showmessage");

  const showToast = (message: string) => {
    toast(<NotificationToastContent message={message} />, {
      containerId: containerId,
    });
  };

  useEffect(() => {
    if (
      data &&
      (showMessageQueryParam === "u" || showMessageQueryParam === "l")
    ) {
      let message = "";
      if (
        !club?.active &&
        membership?.linked &&
        !membership?.subscription?.active
      ) {
        message =
          "Catch and OnePass accounts linked. No active subscription found.";
      } else if (
        !club?.active &&
        membership?.linked &&
        membership?.subscription?.active &&
        membership?.subscription?.onFreeTrial
      ) {
        message =
          showMessageQueryParam === "l"
            ? "Catch and OnePass accounts linked."
            : "OnePass free trial activated.";
      } else if (
        !club?.active &&
        membership?.linked &&
        membership?.subscription?.active &&
        !membership?.subscription.onFreeTrial
      ) {
        message =
          showMessageQueryParam === "l"
            ? "Catch and OnePass accounts linked."
            : "OnePass subscription activated.";
      } else if (
        club?.active &&
        membership?.linked &&
        !membership?.subscription?.active
      ) {
        message =
          showMessageQueryParam === "l"
            ? "Catch and OnePass accounts linked."
            : "";
      }
      if (message) {
        if (showMessageQueryParam === "u") {
          emitUpsellNotification({
            type: "success",
            message,
          });
        } else if (showMessageQueryParam === "l") {
          emitLinkingNotification({
            type: "success",
            message,
          });
        }
        showToast(message);
      }
    }
  }, [
    club?.active,
    data,
    membership?.linked,
    membership?.subscription?.active,
    membership?.subscription?.onFreeTrial,
    showMessageQueryParam,
  ]);

  return <NotificationToastContainer containerId={containerId} />;
};

export const OnePassNotificationWithApollo = withApollo({
  uri: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string,
})(OnePassNotification);
